import { useEffect, useState } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { FullscreenSpinner } from '../../components/feedback/circular'
import { SessionService } from '../../services/session/SessionService'

export default function AuthenticatedRoute({
	children,
	render,
	...rest
}: RouteProps) {
	const sessionService = SessionService.getInstance()

	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		if (sessionService.isAuthenticated) {
			setIsLoading(false)
			return
		}

		sessionService
			.signInAnonymous()
			.catch((e) => {
				console.error(e)
			})
			.finally(() => setIsLoading(false))
	}, [sessionService.isAuthenticated])

	if (isLoading) return <FullscreenSpinner />

	return (
		<Route
			{...rest}
			render={(props) => {
				if (sessionService.isAuthenticated) {
					if (render !== undefined) return render(props)

					return <>{children}</>
				}

				return (
					<Redirect
						to={{
							/* rendering a redirect immediately replaces the current location
						pretty interesting but not very obvious, much prefer the declarative approach */
							pathname: '/_login',
							state: { from: props.location },
						}}
					/>
				)
			}}
		/>
	)
}
